import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import PageIcon from "@atlaskit/icon/core/page";
import ShareIcon from "@atlaskit/icon/core/share";
import SyncIcon from "@atlaskit/icon-lab/core/sync";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components/link/src/link";
import { ContentTypeImage } from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/content-type-image.tsx";
import type {
    TabProps,
    TabType
} from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/tab-type.tsx";
import { tabbedHeroSectionMeetingRecapMessages } from "@/templates/home/home-page/src/sections-v2/reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

type MeetingsContentTypeProps = TabProps;

export const MeetingsContentType: TabType = ({}: MeetingsContentTypeProps) => {
    const intl = useIntl();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { user } = useUserContext();

    return (
        <ContentTypeImage
            imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/5dt721bjgk6lx68w8xdt14h2080w882f.webp"
            imageAlt="This is an screenshot of a Loom meeting recap."
            title={intl.formatMessage(
                tabbedHeroSectionMeetingRecapMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionMeetingRecapMessages.contentDescription
            )}
            hideSeparator={true}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionMeetingRecapMessages.contentFeaturePoint1
                    ),
                    icon: <PageIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionMeetingRecapMessages.contentFeaturePoint2
                    ),
                    icon: <ShareIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionMeetingRecapMessages.contentFeaturePoint3
                    ),
                    icon: <SyncIcon label="" />
                }
            ]}
            cta={
                // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                <Link
                    href={"/software/loom"}
                    text={intl.formatMessage(
                        tabbedHeroSectionMeetingRecapMessages.contentCta
                    )}
                    type={"primary"}
                    dataEventProps={{
                        "data-product-key": "loom",
                        "data-event-component": "linkButton",
                        "data-event-container": "tabsMenu",
                        "data-event": "clicked",
                        "data-label": "try-it-out",
                        "data-label-english": "Explore Loom",
                        "data-track-event": "loom-pt.content-types.video.cta"
                    }}
                    onClick={() => {
                        createAnalyticsEvent({
                            eventName: "loom-crossflow-tab-cta-clicked",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "linkButton",
                            actionSubjectId: "loomCrossFlowHeroSection",
                            attributes: {
                                reactComponent: "MeetingsContentType",
                                tab: "meetings",
                                userTeamType:
                                    user["extended_profile"]?.team_type
                            }
                        }).fire();
                    }}
                />
            }
            reverseLayout
        />
    );
};
